import { isNil } from '@atlas/core';

export function createCurrentURL() {
  const url = new URL(location.pathname, location.origin);

  const current_search = new URLSearchParams(location.search);

  url.search = current_search;

  return url;
}

export function createURL(path = '/', search = {}) {
  const url = new URL(path, location.origin);

  const current_search = new URLSearchParams(location.search);

  // Override existed with provided search params
  for (const [key, value] of Object.entries(search)) {
    if (isNil(value)) {
      current_search.delete(key);
    } else {
      current_search.append(key, value);
    }
  }

  url.search = current_search;

  return url;
}

export function createURLFromSearch(new_search = {}) {
  // Creating current url representation
  const url = new URL(location.pathname, location.origin);

  const current_search = new URLSearchParams(location.search);

  // Override existed with provided search params
  for (const [key, value] of Object.entries(new_search)) {
    if (isNil(value)) {
      current_search.delete(key);
    } else {
      current_search.set(key, value);
    }
  }

  url.search = current_search;

  return url;
}

export function encodeURIComponentWithSpecialSymbols(url = '') {
  if (!url) return url;
  return encodeURIComponent(url).replace(
    /[!'()*]/g,
    c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
  );
}
